import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["placeholder", "aria-describedby", "id"]
const _hoisted_2 = ["placeholder", "aria-describedby", "aria-invalid", "id"]
const _hoisted_3 = ["placeholder", "aria-describedby", "id"]
const _hoisted_4 = ["placeholder", "aria-describedby", "id"]
const _hoisted_5 = ["placeholder", "aria-describedby", "id"]

import ValidatedInput from "@/builder/components/input/ValidatedInput.vue";
import { FieldStyle } from "@/builder/enums";
import { useRenderStore } from "@/builder/stores/renderStore";
import { computed, inject, PropType, Ref } from "vue";
import { PageDesign } from "../page/PageInterface";
import { INameInputCustomData, ITextInputComponent } from "./TextInputInterface";


export default /*@__PURE__*/_defineComponent({
  __name: 'NameInputComponent',
  props: {
    component: {
        type: Object as PropType<ITextInputComponent>,
        required: true,
    },
},
  setup(__props) {

const renderStore = useRenderStore();

const props = __props;

const pageDesign = inject("pageDesign") as Ref<PageDesign>;
const fieldStyle = computed(() => {
    return pageDesign.value.fieldStyle;
});

const customData = computed(() => {
    return props.component.customData as INameInputCustomData;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-row name-container", { 'rd-gap-x-4': fieldStyle.value != _unref(FieldStyle).Compact }])
  }, [
    (customData.value.title)
      ? (_openBlock(), _createBlock(ValidatedInput, {
          key: 0,
          id: __props.component.id,
          value: _unref(renderStore).donor.title,
          label: customData.value.titleLabel,
          name: "Donor.Title",
          class: "rd-w-full md:rd-w-1/6",
          isRequired: false,
          maxLength: 75
        }, {
          input: _withCtx((inputProps) => [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(renderStore).donor.title) = $event)),
              placeholder: customData.value.titlePlaceholder,
              "aria-describedby": inputProps.describedBy,
              id: __props.component.id + '_Donor.Title',
              autocomplete: "honorific-prefix"
            }, null, 8, _hoisted_1), [
              [_vModelText, _unref(renderStore).donor.title]
            ])
          ]),
          _: 1
        }, 8, ["id", "value", "label"]))
      : _createCommentVNode("", true),
    _createVNode(ValidatedInput, {
      id: __props.component.id,
      value: _unref(renderStore).donor.firstName,
      label: customData.value.firstNameLabel,
      name: "Donor.FirstName",
      class: _normalizeClass(["rd-w-full md:rd-flex-equal", { 'rd-mt-4 md:rd-mt-0': customData.value.title && fieldStyle.value != _unref(FieldStyle).Compact }]),
      isRequired: __props.component.customData.required,
      maxLength: 75
    }, {
      input: _withCtx((inputProps) => [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(renderStore).donor.firstName) = $event)),
          placeholder: customData.value.firstNamePlaceholder,
          "aria-describedby": inputProps.describedBy,
          "aria-invalid": inputProps.isInvalid,
          "aria-required": "true",
          id: __props.component.id + '_Donor.FirstName',
          autocomplete: "given-name"
        }, null, 8, _hoisted_2), [
          [_vModelText, _unref(renderStore).donor.firstName]
        ])
      ]),
      _: 1
    }, 8, ["id", "value", "label", "class", "isRequired"]),
    (customData.value.middleName)
      ? (_openBlock(), _createBlock(ValidatedInput, {
          key: 1,
          id: __props.component.id,
          value: _unref(renderStore).donor.middleName,
          label: customData.value.middleNameLabel,
          name: "Donor.MiddleName",
          class: _normalizeClass(["rd-w-full md:rd-flex-equal", { 'rd-mt-4 md:rd-mt-0': fieldStyle.value != _unref(FieldStyle).Compact }]),
          isRequired: false,
          maxLength: 75
        }, {
          input: _withCtx((inputProps) => [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(renderStore).donor.middleName) = $event)),
              placeholder: customData.value.middleNamePlaceholder,
              "aria-describedby": inputProps.describedBy,
              id: __props.component.id + '_Donor.MiddleName',
              autocomplete: "additional-name"
            }, null, 8, _hoisted_3), [
              [_vModelText, _unref(renderStore).donor.middleName]
            ])
          ]),
          _: 1
        }, 8, ["id", "value", "label", "class"]))
      : _createCommentVNode("", true),
    _createVNode(ValidatedInput, {
      id: __props.component.id,
      value: _unref(renderStore).donor.lastName,
      label: customData.value.lastNameLabel,
      name: "Donor.LastName",
      class: _normalizeClass(["rd-w-full md:rd-flex-equal", { 'rd-mt-4 md:rd-mt-0': fieldStyle.value != _unref(FieldStyle).Compact }]),
      isRequired: __props.component.customData.required,
      maxLength: 75
    }, {
      input: _withCtx((inputProps) => [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(renderStore).donor.lastName) = $event)),
          placeholder: customData.value.lastNamePlaceholder,
          "aria-describedby": inputProps.describedBy,
          "aria-required": "true",
          id: __props.component.id + '_Donor.LastName',
          autocomplete: "family-name"
        }, null, 8, _hoisted_4), [
          [_vModelText, _unref(renderStore).donor.lastName]
        ])
      ]),
      _: 1
    }, 8, ["id", "value", "label", "class", "isRequired"]),
    (customData.value.suffix)
      ? (_openBlock(), _createBlock(ValidatedInput, {
          key: 2,
          id: __props.component.id,
          value: _unref(renderStore).donor.suffix,
          label: customData.value.suffixLabel,
          name: "Donor.Suffix",
          class: _normalizeClass(["rd-w-full md:rd-w-1/6", { 'rd-mt-4 md:rd-mt-0': fieldStyle.value != _unref(FieldStyle).Compact }]),
          isRequired: false,
          maxLength: 75
        }, {
          input: _withCtx((inputProps) => [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(renderStore).donor.suffix) = $event)),
              placeholder: customData.value.suffixPlaceholder,
              "aria-describedby": inputProps.describedBy,
              id: __props.component.id + '_Donor.Suffix',
              autocomplete: "honorific-suffix"
            }, null, 8, _hoisted_5), [
              [_vModelText, _unref(renderStore).donor.suffix]
            ])
          ]),
          _: 1
        }, 8, ["id", "value", "label", "class"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})